import React from 'react';
import { useTranslation } from '@shared/core';
import { SimpleGrabHandle } from '@website-editor/components/SimpleGrabHandle';
import { LockLight } from '@withjoy/joykit/icons';
import { AdminSidebarComponentProps } from '../../JsonComponent.types';
import { useToast } from '@withjoy/joykit';

export const RsvpBlockGrabber = (props: AdminSidebarComponentProps) => {
  const { tq } = useTranslation('rsvpCustomComponent');
  const { toast } = useToast();

  return (
    <SimpleGrabHandle
      title={tq`RSVP/Unlock Button`}
      subTitle={tq`Access to RSVP for your guests`}
      icon={<LockLight size="lg" />}
      disableEdit={true}
      handleClick={() => {
        toast(tq`RSVP/Unlock Button component is not editable.`);
      }}
      {...props}
    />
  );
};
